<template>
  <AppSection id="help-center-page" :title="$getConst.menu.help_center.name" type="page">

    <div id="help-content" v-if="!isLoading" v-html="helpContent"></div>
    <hr v-if="!isLoading">
    <Attachments
      v-if="!isLoading && attachments.length"
      :editable="false"
      :file-infos="attachments"
    />
    <AppSpinner v-if="isLoading" size="3" class="d-block m-4 mx-auto text-secondary"/>

  </AppSection>
</template>

<script>
  import AppSection from "../../components/common/sections/AppSection";
  import AppSpinner from "../../components/common/utils/AppSpinner";
  import {getScopeLanguageHelpContent} from "../../api/helpContent.api";
  import Attachments from "../../components/common/attachments/Attachments";
  export default {
    name: "index",
    components: {Attachments, AppSpinner, AppSection},
    data() {
      return {
        helpContent: null,
        attachments: [],
        scopeId: this.$store.getters["auth/scopeDefault"].id,
        languageId: this.$store.getters["auth/userPersonalDetails"].language.id,
        isLoading: false
      }
    },
    methods: {
      getData() {
        this.isLoading = true;
        getScopeLanguageHelpContent(this.scopeId, this.languageId).then(
          (response) => {
            this.helpContent = response.data.help_content;
            this.attachments = response.data.attachments;
            this.isLoading = false;
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading = false;
          }
        )
      }
    },
    created() {
      this.getData();
    }
  }
</script>

<style scoped>

</style>
